export default __webpack_public_path__ + "static/media/logo-go-smart.0191b62b.svg";